import React, { useState } from "react";
import HeroImage from "../../assets/image/hero-image.png";
import { CiHeart } from "react-icons/ci";
import { FiShare } from "react-icons/fi";
import { BsCalendarRange, BsChatLeftText, BsPeople } from "react-icons/bs";

function BootcampPage() {
  const [activeTab, setActiveTab] = useState("overview");

  const scrollToSection = (id) => {
    setActiveTab(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <section className="hero-section">
        <div className="container py-5">
          <div className="row align-items-center gy-5">
            {/* Left */}

            <div className="col-lg-6">
              {/* <span className="hero-badge"> 🚀 30-Day UI/UX Bootcamp </span> */}

              <h1 className="hero-title mt-4">
                Master UI/UX Design
                <br />
                <span>in 30 Days</span>
              </h1>

              <p className="hero-description">
                Learn industry-standard UI/UX design through live sessions,
                real-world projects, personalized mentorship, and portfolio
                reviews that prepare you for your first design role.
              </p>

              <div className="hero-buttons">
                <button
                  className="btn hero-primary-btn"
                  onClick={() => scrollToSection("overview")}
                >
                  Enroll Now
                </button>

                <button className="btn hero-secondary-btn">
                  View Curriculum
                </button>
              </div>

              <div className="hero-stats">
                <div className="stat-item">
                  <h4>4.9★</h4>
                  <span>Student Rating</span>
                </div>

                <div className="divider"></div>

                <div className="stat-item">
                  <h4>5,000+</h4>
                  <span>Students</span>
                </div>

                <div className="divider"></div>

                <div className="stat-item">
                  <h4>30</h4>
                  <span>Days</span>
                </div>

                <div className="divider"></div>

                <div className="stat-item">
                  <h4>Certificate</h4>
                  <span>Included</span>
                </div>
              </div>
            </div>

            {/* Right */}

            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div className="hero-image-wrapper">
                <img src={HeroImage} alt="UI UX" className="hero-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container my-5">
        <div className="row align-items-center">
          <div className="col-lg-3 mb-4">
            <h2 className="fw-bold" style={{ color: "#1a1a2e" }}>
              Elevate Your Skills 🔥
            </h2>
            <p className="text-muted">
              Join Datacode's 30-Day UI/UX Bootcamp for Unmatched Benefits!
            </p>
          </div>
          <div className="col-lg-9">
            <div className="row g-4">
              <div className="col-md-4">
                <BsCalendarRange
                  className="icon-size mb-3"
                  style={{ color: "#6f42c1" }}
                />
                <p className="fw-bold mb-1">30 Days Hands-on</p>
                <p className="text-muted small">
                  New problem each day for the next 30 days
                </p>
              </div>
              <div className="col-md-4">
                <BsChatLeftText
                  className="icon-size mb-3"
                  style={{ color: "#6f42c1" }}
                />
                <p className="fw-bold mb-1">Personalized Feedback</p>
                <p className="text-muted small">
                  Receive personalized feedback and mentorship from
                  professionals
                </p>
              </div>
              <div className="col-md-4">
                <BsPeople
                  className="icon-size mb-3"
                  style={{ color: "#6f42c1" }}
                />
                <p className="fw-bold mb-1">Networking Opportunities</p>
                <p className="text-muted small">
                  Connect with industry professionals and peers
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mb-5">
        <div
          className="d-flex justify-content-around bg-white rounded shadow-sm p-3"
          style={{ border: "1px solid #eee" }}
        >
          <span
            className="nav-link fw-bold"
            style={{
              color: activeTab === "overview" ? "#6f42c1" : "#6c757d",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("overview")}
          >
            Overview
          </span>
          <span
            className="nav-link fw-bold"
            style={{
              color: activeTab === "roadmap" ? "#6f42c1" : "#6c757d",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("roadmap")}
          >
            Roadmap
          </span>
          <span
            className="nav-link fw-bold"
            style={{
              color: activeTab === "requirements" ? "#6f42c1" : "#6c757d",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("requirements")}
          >
            Requirements
          </span>
          <span
            className="nav-link fw-bold"
            style={{
              color: activeTab === "reviews" ? "#6f42c1" : "#6c757d",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("reviews")}
          >
            Reviews
          </span>
          <span
            className="nav-link fw-bold"
            style={{
              color: activeTab === "faq" ? "#6f42c1" : "#6c757d",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("faq")}
          >
            FAQ
          </span>
        </div>
      </div>
    </>
  );
}

export default BootcampPage;
